import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY_DEV || "your_api_key_here",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_DEV || "your_project_id.firebaseapp.com",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL_DEV || "https://your_project_id-default-rtdb.firebaseio.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_DEV || "your_project_id",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_DEV || "your_project_id.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_DEV || "your_messaging_sender_id",
  appId: process.env.REACT_APP_FIREBASE_APP_ID_DEV || "your_app_id",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_DEV || "your_measurement_id",
};

// Debug: Log Firebase config (remove in production)
console.log('Firebase Config:', {
  apiKey: firebaseConfig.apiKey ? 'Set' : 'Missing',
  authDomain: firebaseConfig.authDomain ? 'Set' : 'Missing',
  projectId: firebaseConfig.projectId ? 'Set' : 'Missing',
  appId: firebaseConfig.appId ? 'Set' : 'Missing'
});

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Initialize Analytics (optional)
let analytics;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}
export { analytics };
